export default __webpack_public_path__ + "static/media/uitzichtKlein.2a3d8112.jpg";